/**
 * @file Renders the modal that lets a Backstage user jump to an investment by its wire reference code.
 */
import { useState, type MutableRefObject } from "react";
import { Space } from "antd";

import { Modal } from "@components/Page";
import { W1, MODAL_WIDTH2 } from "@components/Constants";

import GoToInvestmentForm from "./GoToInvestmentForm";

const LABEL_TITLE = "Go To Investment";

type ModalControls = {
  open?: () => void;
};

type Props = {
  modal: MutableRefObject<ModalControls>;
};

/**
 * Renders the modal that lets a Backstage user jump to an investment by its wire reference code.
 */
const GoToInvestmentModal = ({ modal }: Props) => {
  const [ isOpen, setIsOpen ] = useState(false);

  /**
   * Opens the modal, exposed to the caller through the modal ref.
   */
  modal.current.open = () => setIsOpen(true);

  /**
   * Closes the modal.
   */
  const onClose = () => {
    setIsOpen(false);
  };

  const modalProps = {
    title: LABEL_TITLE,
    width: MODAL_WIDTH2,
    destroyOnClose: true,
    isOpen,
    onClose,
  };

  return (
    <Modal {...modalProps}>
      <Space direction="vertical" size={W1}>
        <GoToInvestmentForm onSuccess={onClose} />
      </Space>
    </Modal>
  );
};

export default GoToInvestmentModal;
